var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-col",
    { staticClass: "root", attrs: { xs: "3" } },
    [
      _c(
        "w-container",
        { style: { overflowX: "hidden" } },
        [
          _c(
            "w-scroll-view",
            { style: { height: "auto" }, attrs: { tag: "w-card" } },
            [
              _c(
                "w-list",
                _vm._l(_vm.tabs, function (tab) {
                  return _c(
                    "w-list-item",
                    {
                      key: tab.value,
                      class: { active: _vm.value == tab.value },
                      on: {
                        click: function ($event) {
                          return _vm.clicked(tab.value)
                        },
                      },
                    },
                    [_c("w-list-item-text", [_vm._v(_vm._s(tab.text))])],
                    1
                  )
                }),
                1
              ),
              _c("w-spacer"),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }